import React, { forwardRef, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ExternalLink from '../ExternalLink';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    type?: 'button' | 'submit' | 'reset' | undefined;
    variant?: 'primary' | 'secondary' | 'tertiary' | 'transparent' | 'danger';
    className?: string;
    internalLink?: string;
    externalLink?: string;
    reverseTheme?: boolean;
    onClick?: any;
    children?: ReactNode;
}

type Ref = HTMLButtonElement | HTMLAnchorElement;

const Button = forwardRef<Ref, ButtonProps>(
    (
        {
            type = 'button',
            variant = 'primary',
            className = '',
            externalLink,
            internalLink,
            reverseTheme = false,
            onClick,
            children,
            ...rest
        },
        ref
    ) => {
        const buttonClassName = `custom ${className} button-${variant}`;

        if (internalLink) {
            return (
                <Link
                    to={internalLink}
                    className={buttonClassName}
                    onClick={onClick}
                    ref={ref as React.ForwardedRef<HTMLAnchorElement>}
                >
                    {children}
                </Link>
            );
        }

        if (externalLink) {
            return (
                <ExternalLink
                    to={externalLink}
                    className={buttonClassName}
                    onClick={onClick}
                    ref={ref as React.ForwardedRef<HTMLAnchorElement>}
                >
                    {children}
                </ExternalLink>
            );
        }

        return (
            <button
                ref={ref as React.ForwardedRef<HTMLButtonElement>}
                type={type}
                className={buttonClassName}
                onClick={onClick}
                {...rest}
            >
                {children}
            </button>
        );
    }
);

export default Button;
